<div class="full-width full-height pl-20 pr-20 overflow" [innerHTML]="widget.config.content"></div>
